<template>
    <div class="container AuditContainer">
        <a-tabs default-active-key="1" class="container">
            <a-tab-pane key="1" class="container">
                <span slot="tab">待审核</span>
                <a-list item-layout="vertical" :data-source="waitAudit"
                    class="listContainer" :locale="{ emptyText: '当前没有待审批的更新' }">
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-list-item-meta
                            :description="item.comment"
                        >
                            <a slot="title" :href="`/score.php?name=${ item.name }&num=10`" target="_blank">{{ item.title }}</a>
                        </a-list-item-meta>
                        <template slot="extra">
                            {{ getStatus(item.status) }}<br/><br/>
                            <a-space>
                                <a-button v-if="item.status === 1" @click="approve(item.id)">通过</a-button>
                                <a-button v-else @click="callAuditModel(item.id)">移动</a-button>
                                <a-button @click="reject(item.id)" type="danger">拒绝</a-button>
                            </a-space>
                        </template>
                        <template slot="actions">
                            <span>
                                {{ item.username }}
                                (<a :href="'/user/user.php?uid='+item.userId" target="_blank">id: {{ item.userId }}</a>)
                            </span>
                            <span>
                                <a-icon type="clock-circle" style="margin-right: 8px" />
                                {{ item.uploadTime }}
                            </span>
                            <span>
                                <a-icon type="file-zip" style="margin-right: 8px" />
                                <a :href="'/backend/admin/tower/downloadUpdate.php?name='+item.name">{{ formatSize(item.size) }}</a>
                            </span>
                        </template>
                    </a-list-item>
                </a-list>
            </a-tab-pane>
            <a-tab-pane key="2" class="container">
                <span slot="tab">审核记录</span>
                <a-list item-layout="vertical" :data-source="auditRecord"
                    class="listContainer">
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-list-item-meta
                            :description="item.comment"
                        >
                            <a slot="title" :href="`/score.php?name=${ item.name }&num=10`" target="_blank">{{ item.title }}</a>
                        </a-list-item-meta>
                        <div slot="extra">
                            <br/>
                            {{ getStatus(item.status) }}<br/>
                            <a :href="`/user/user.php?uid=${ item.reviewerId }`" target="_blank">{{ item.reviewerName }}</a><br/>
                            {{ item.reviewTime }}
                        </div>
                        <template slot="actions">
                            <span>
                                {{ item.username }}
                                (<a :href="`/user/user.php?uid=${ item.userId }`" target="_blank">id: {{ item.userId }}</a>)
                            </span>
                            <span>
                                <a-icon type="clock-circle" style="margin-right: 8px" />
                                {{ item.uploadTime }}
                            </span>
                            <span>
                                <a-icon type="file-zip" style="margin-right: 8px" />
                                {{ formatSize(item.size) }}
                            </span>
                        </template>
                    </a-list-item>
                </a-list>
            </a-tab-pane>
        </a-tabs>
        <a-modal
            :title="`审核 - ${ auditItem.title }`"
            :visible="auditVisible" :width="'85%'"
            :okButtonProps="{
                props: { disabled: approving }
            }"
            :confirm-loading="confirmLoading"
            @ok="comfirm(auditItem.id)"
            @cancel="cancel"
        >
            <pre class="message">{{ auditItem.msg }}</pre>
            更新第三方音乐:<a-switch v-model="bgmremote"></a-switch>
        </a-modal>
    </div>
</template>

<script>
import axios from '../../../plugins/axios';
import { createFormData } from '../../../utils/utils';
export default {
    data: () => ({
        waitAudit: [],
        auditRecord: [],
        auditVisible: false,
        confirming: false,
        auditItem: {},
        confirmLoading: false,
        approving: false,
        bgmremote: false,
    }),
    created() {
        this.load();
    },
    methods: {
        getStatus(status) {
            return {
                1: "等待审核",
                2: "正在审核",
                6: "解压出错",
                7: "移动出错",
                10: "审核通过",
                11: "已被拒绝",
            }[status] || "未知";
        },
        formatSize(size) {
            if (size<1024) return size + "B";
            if (size<1024*1024) return (size/1024).toFixed(2) + "KB";
            if (size<1024*1024*1024) return (size/1024/1024).toFixed(2) + "MB";
            return (size/1024/1024/1024).toFixed(2) + "GB";
        },
        load() {
            axios.get("/backend/admin/tower/auditRecord.php")
                .then(({ data }) => {
                    const auditRecord = [], waitAudit = [];
                    for (let item of data.list) {
                        item.status = Number(item.status);
                        if (item.status === 1) {
                            waitAudit.push(item);
                        } else {
                            auditRecord.push(item);
                        }
                    }
                    this.waitAudit = waitAudit;
                    this.auditRecord = auditRecord;
                });
        },
        approve(id) {
            this.approving = true;
            this.callAuditModel(id, true);
            this.auditItem = this.waitAudit.find((e) => e.id == id);
            this.auditVisible = true;
            axios.post("/backend/admin/tower/doAudit.php", createFormData({
                id, type: "yes"
            })).then(({ data }) => {
                    this.waitAudit.find((e) => e.id == id).msg = data.msg;
                    if (data.code == 0) {
                        this.approving = false;
                    } else {
                        this.$message.error("操作失败");
                    }
                })
        },
        reject(id) {
            axios.post("/backend/admin/tower/doAudit.php", createFormData({
                id, type: "no"
            })).then(({ data }) => {
                    if (data.code == 0) {
                        this.load();
                        this.$message.error("操作成功");
                    } else {
                        this.$message.error("操作失败");
                    }
                })
        },
        callAuditModel(id) {
            console.log(id);
        },
        comfirm(id) {
            this.confirmLoading = true;
            axios.post("/backend/admin/tower/doAudit.php", createFormData({
                id, type: "confirm", bgm_remote: this.bgmremote,
            })).then(({ data }) => {
                    if (data.code == 0) {
                        this.confirmLoading = false;
                        this.auditVisible = false;
                        this.$message.success("操作成功");
                        this.load();
                    } else {
                        this.$message.error("操作失败");
                    }
                })
        },
        cancel() {
            this.auditVisible = false;
            this.approving = false;
            this.load();
        }
    }
}
</script>

<style lang="less">
.AuditContainer {
    .ant-tabs-content {
        height: calc(100% - 58px);
        .ant-list-item {
            margin-right: 10px;
        }
        .ant-list-item-main {
            text-align: left;
        }
    }
}
</style>

<style lang="less" scoped>
.container {
    height: 100%;
    flex-wrap: nowrap;
}
.listContainer {
    height: 100%;
    overflow-y: auto;
}
pre.message {
    height: 300px;
    overflow: auto;
}
</style>